
<template>
   <div class="form-group">
      <span
         v-if="isNormal"
         v-text="message"
      ></span>
      <p
         v-if="mutedText"
         class="text-muted"
      >
         {{ mutedText }}
      </p>
      <label
         v-if="!isNormal"
         for="ip_message"
         :class="['label-overlay', {active: !isNotEmpty(form.message)}]"
         @click="switchLabel($event)"
      >
         {{ message }}
      </label>
      <textarea
         id="ip_message"
         v-model.trim="form.message"
         class="form-control"
         name="message"
         :placeholder="isNormal ? placeHolder : text"
         :class="[{ 'is-invalid': !optional && isValidName.isInvalid },
                  { 'is-valid':  isValidName.isValid }]"
         @click="!isNormal && isPlaceHolderVisible && showPlacehoder($event)"
         @focus="!isNormal && switchLabel($event)"
         @blur="!isNormal && switchLabel($event); validateMessageData();"
      />
      <small
         v-if="optional"
         :class="['form-text optional-text', {active: form.message.length === 0}]"
      >
         Optional
      </small>
      <div class="invalid-feedback">Tell us a bit more, so that we can help you better.</div>
      <div class="valid-feedback">That sounds good.</div>
   </div>
</template>

<script>
export default {
   name: 'MessageComponent',
   props: {
      message: {
         type: String,
         default: 'Your query/message',
      },
      mutedText: {
         type: String,
         default: '',
      },
      placeHolder: {
         type: String,
         default:
            'Media site, blog, customer presentation, product dashboard, market research report',
      },
      invalidFeedback: {
         type: String,
         default: 'Tell us a bit more, so that we can help you better.',
      },
      validFeedback: {
         type: String,
         default: 'That sounds good.',
      },
      isPlaceHolderVisible: {
         type: Boolean,
         default: false,
      },
      isNormal: {
         type: Boolean,
         default: false,
      },
      optional: {
         type: Boolean,
         default: false,
      },
      value: {
         type: String,
         default: '',
      },
   },
   data() {
      return {
         isValidName: {
            isValid: false,
            isInvalid: false,
         },
         form: {
            message: this.value,
         },
         text: '',
      };
   },
   methods: {
      validateMessageData() {
         this.isValidName.isValid = !this.isNotEmpty(this.form.message);
         this.isValidName.isInvalid = this.$parent.attemptSubmit && this.isNotEmpty(this.form.message);
      },
      showPlacehoder(e) {
         e.preventDefault();
         this.text = this.placeHolder;
      },
   },
};
</script>

<style lang="scss">
.second-step {
   span {
      margin: 8px 0;
   }
   p.text-muted {
      opacity: 0.6;
      color: #5a5b75;
      font-size: 14px;
      line-height: 18px;
   }
   textarea {
      min-height: 42px;
      height: 42px;
      padding: 11px 16px;
   }
}
</style>
